<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.fai_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd">
          <div class="weui-form-preview__item" slot="pr_code">
            <label class="weui-form-preview__label">{{
              customLabel.pr_code || "物料编号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_code
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{
              customLabel.pr_detail || "物料名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_orispeccode"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_orispeccode || "型号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_orispeccode
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_spec"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_spec || "规格"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_spec
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_brand"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_brand || "厂家/品牌"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_brand
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_kind"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_kind || "物料类型"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.pr_kind }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="fai_macode">
            <label class="weui-form-preview__label">{{
              customLabel.fai_macode || "生产工单"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_macode
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="fai_qty"
           
          >
            <label class="weui-form-preview__label">{{
              customLabel.fai_qty || "批量"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_qty
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="fai_custname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.fai_custname || "客户"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="fai_date">
            <label class="weui-form-preview__label">{{
              customLabel.fai_date || "检验时间"
            }}</label>
            <span
              class="weui-form-preview__value"
              v-format="'yyyy-MM-dd hh:mm:ss'"
              >{{ form.main.fai_date }}</span
            >
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.fd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="fd_item">
              <label class="weui-form-preview__label">{{
                customLabel.fd_item || "检查项目"
              }}</label>
              <span class="weui-form-preview__value">{{ item.fd_item }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fd_standard">
              <label class="weui-form-preview__label">{{
                customLabel.fd_standard || "检查标准"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.fd_standard
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fd_test">
              <label class="weui-form-preview__label">{{
                customLabel.fd_test || "样本实测"
              }}</label>
              <span class="weui-form-preview__value">{{ item.fd_test }}</span>
            </div>
            <div class="weui-form-preview__item" slot="fd_result">
              <label class="weui-form-preview__label">{{
                customLabel.fd_result || "检验结果"
              }}</label>
              <span class="weui-form-preview__value">{{ item.fd_result }}</span>
            </div>
          </custom-layout>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <custom-layout class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item" slot="fai_result">
            <label class="weui-form-preview__label">{{
              customLabel.fai_result || "判定结果"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_result
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="fai_ng_desc">
            <label class="weui-form-preview__label">{{
              customLabel.fai_ng_desc || "不合格描述"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_ng_desc
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="fai_checkman">
            <label class="weui-form-preview__label">{{
              customLabel.fai_checkman || "检验员"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_checkman
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="fai_scdirector">
            <label class="weui-form-preview__label">{{
              customLabel.fai_scdirector || "生产负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_scdirector
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="fai_gcdirector">
            <label class="weui-form-preview__label">{{
              customLabel.fai_gcdirector || "工程负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_gcdirector
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="fai_ng_desc">
            <label class="weui-form-preview__label">{{
              customLabel.fai_scdirector || "QC组长"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_scdirector
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="fai_remark">
            <label class="weui-form-preview__label">{{
              customLabel.fai_remark || "备注"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.fai_remark
            }}</span>
          </div>
        </custom-layout>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/storage/firstqc/",
      caller: "FirstQc",
      xtype: "stock-firstqc-formpanel",
    };
  },
};
</script>